import React from 'react';
import { declOfNum } from '@ertelecom/ui-react/components/helpers';
import { Wrapper, Text, Price, PriceNumber, OldPrice, PriceText, Delete, CheckBox } from './styled';
import DeleteIcon from '~/src/components/Icons/DeleteIcon';
import TooltipContainer from './Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { setCheckListAction } from '~/src/store/actions/village-detail';


const getDeclensionOfMonth = declOfNum(['месяц', 'месяца', 'месяцев']);

const ItemCheckList = (
    {
        name,
        price,
        oldPrice,
        deleteItem,
        priceText,
        isSideBar,
        onSelect,
        selected,
        tooltip,
        isPaddingText,
        promoPeriod,
        required,
        materialsEnsId,
    },
) => {
    const dispatch = useDispatch();
    const checkList = useSelector(state => state.villageDetail.checkList);
    const removeItem = () => {
        const augmentedCheck = { ...checkList };
        const monthly = { ...augmentedCheck.monthly };
        const newListMonthly = monthly.list.filter(equipment => {
            if (equipment.materialsEnsId === materialsEnsId) {
                monthly.total -= equipment.price;
                return false;
            } else {
                return true;
            }
        });
        monthly.list = newListMonthly;

        const once = { ...augmentedCheck.once };
        const newOnce = once.list.filter(equipment => {
            if (equipment.materialsEnsId === materialsEnsId) {
                once.total -= equipment.price;
                return false;
            } else {
                return true;
            }
        });
        once.list = newOnce;

        augmentedCheck.monthly = monthly;
        augmentedCheck.once = once;
        dispatch(setCheckListAction(augmentedCheck));
    };

    return (
        <Wrapper isSideBar={isSideBar}>
            <Text isSideBar={isSideBar} isPadding={isPaddingText}>
                {name}
                {promoPeriod ? ` (по акции на ${promoPeriod} ${getDeclensionOfMonth(promoPeriod)})` : ''}
            </Text>
            {!required &&
                <Price isSideBar={isSideBar}>
                    <PriceNumber isSideBar={isSideBar}>
                        {oldPrice && oldPrice > price && <OldPrice>{oldPrice}</OldPrice>}
                        {price}
                    </PriceNumber>
                    <PriceText isSideBar={isSideBar}>{priceText}</PriceText>
                </Price>
            }

            {
                deleteItem &&
                <Delete onClick={removeItem}>
                    {DeleteIcon()}
                </Delete>
            }
            {
                onSelect && !required &&
                <CheckBox onClick={onSelect} selected={selected}/>
            }
            {
                tooltip &&
                <TooltipContainer text={tooltip}/>
            }
        </Wrapper>
    );
};

export default ItemCheckList;
